import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

interface ComparisonToggleProps {
  value: 'on' | 'off';
  onChange: (next: 'on' | 'off') => void;
  disabled: boolean;
}

export function ComparisonToggle({ value, onChange, disabled }: ComparisonToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <Switch
        id="analytics-comparison-toggle"
        checked={value === 'on'}
        onCheckedChange={(checked) => onChange(checked ? 'on' : 'off')}
        disabled={disabled}
      />
      <Label htmlFor="analytics-comparison-toggle" className="text-sm cursor-pointer">
        Compare to prev period
      </Label>
    </div>
  );
}
